import { render, staticRenderFns } from "./Buscador.vue?vue&type=template&id=07590f72&"
import script from "./Buscador.vue?vue&type=script&lang=ts&"
export * from "./Buscador.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('07590f72', component.options)
    } else {
      api.reload('07590f72', component.options)
    }
    module.hot.accept("./Buscador.vue?vue&type=template&id=07590f72&", function () {
      api.rerender('07590f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Grid/Buscador.vue"
export default component.exports